import type { DeviceMessage } from '@maru44/huntre-utils/src/models/deviceMessage'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { collection, getDocs, type Timestamp } from 'firebase/firestore'
import { firestore } from 'src/utils/firebase'
import { filter, safeQuery, sortBy, take } from 'src/utils/firestoreQuery'
import useSWR from '../useSWR'

export const useClientDeviceMessages = (deviceId: string, registeredAt: Timestamp | undefined) => {
  // 登録日以降 & 捕獲 & setupだけ
  const listMessagesForClient = useSWR(
    [`/devices/${deviceId}/deviceMessages?after=`, deviceId],
    async () => {
      // トップレベルの制約は暗黙に AND なので and() は要らない
      const q = safeQuery(
        collection(firestore, `devices/${deviceId}/deviceMessages`),
        filter('createdAt', '>=', registeredAt),
        filter('wakeupCause', 'in', ['ESP_SLEEP_WAKEUP_UNDEFINED', 'ESP_SLEEP_WAKEUP_EXT0', 'ESP_SLEEP_WAKEUP_EXT1']),
        sortBy('createdAt', 'desc'),
        take(20),
      )

      const snap = await getDocs(q)
      return snap.docs.map((v) => getData<DeviceMessage>(v))
    },
    {
      disabled: !deviceId || !registeredAt,
    },
  )

  return { listMessagesForClient }
}
